import React, {useEffect} from 'react';

interface HomeModalShellProps {
  backdropClassName: string;
  panelClassName: string;
  ariaLabelledBy: string;
  ariaDescribedBy?: string;
  onClose: () => void;
  closeDisabled?: boolean;
  children: React.ReactNode;
}

const HomeModalShell: React.FC<HomeModalShellProps> = ({
  backdropClassName,
  panelClassName,
  ariaLabelledBy,
  ariaDescribedBy,
  onClose,
  closeDisabled = false,
  children,
}) => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !closeDisabled) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeDisabled, onClose]);

  return (
    <div
      className={backdropClassName}
      onClick={(event) => {
        if (event.target === event.currentTarget && !closeDisabled) {
          onClose();
        }
      }}
    >
      <div
        className={panelClassName}
        role="dialog"
        aria-modal="true"
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
      >
        {children}
      </div>
    </div>
  );
};

export default React.memo(HomeModalShell);
